const RegionList = [
  {
    name: 'Sydney (Australia)',
    id: 'aus',
  },
  {
    name: 'Montreal (Canada)',
    id: 'ca1',
  },
  {
    name: 'Frankfurt (Europe)',
    id: 'eu1',
  },
  {
    name: 'Mumbai (India)',
    id: 'mum',
  },
  {
    name: 'Singapore (Singapore)',
    id: 'sgp',
  },
  {
    name: 'North Virginia (United States)',
    id: 'us1',
  },
  {
    name: 'North California (United States)',
    id: 'us2',
  },
]

export default RegionList
